<div *ngIf="route" class="header"
    [ngClass]="{'isSlotBlocked':route.isSlotBlocked, 'incompatibleSlot':route.incompatibleSlot}">
    <div class="primeraLinea">
        <div class="leftData">
            <!-- TÍTOL -->
            <div class="line route-title ellipsis pointer">
                {{route.title}}<shared-copyclipboard [value]="route.title"></shared-copyclipboard>
                <span class="route-titlesubtitle pointer">{{route.titleSubtitle}}</span>
            </div>
            <!-- SUBTÍTOL -->
            <div class="line route-subtitle ellipsis">{{route.subtitle}}<shared-copyclipboard
                    [value]="route.subtitle"></shared-copyclipboard>
            </div>

            <!-- DATES -->
            <div class="line route-description ellipsis no-reduced" *ngIf="route.line1">{{ route.line1 }}
            </div>
            <div class="line route-description ellipsis disp no-reduced" *ngIf="route.line2">{{ route.line2 }}
            </div>
            <div class="line route-description ellipsis no-reduced" *ngIf="route.line3">{{ route.line3 }}
            </div>
            <button *ngIf="!useIonic" class="general-link-boto jump no-booking" (click)="goToActiveRoute()"><i
                    class="fa fa-share" aria-hidden="true"></i>{{'SHARED.ACTIVE.ROUTE.PHASE.COMPONENT.OPTION.AR.PROMPT'
                |
                translate}}</button>
        </div>
        <div class="rightData no-reduced">
            <!-- Chevron toggle -->
            <div class="chevron">
                <i class="fa fa-chevron-circle-right" [ngClass]="{'showTimeline':showTimeline}" aria-hidden="true"
                    (click)="toggleView()"></i>
            </div>
            <div class="rest">
                <div *ngIf="!showTimeline" class="container-tags" [@fadeInOut]>
                    <div class="container-tag"><span class="mini-title-tags">{{'TAG.MANUAL.CAPTION' | translate
                            }}:</span><shared-tags-strip-component class="only-single"
                            [tags]="manualTags"></shared-tags-strip-component></div>
                    <div class="container-tag"><span class="mini-title-tags" *ngIf="userTags">{{'TAG.USER.CAPTION' |
                            translate }}:</span><shared-tags-strip-component class="only-single"
                            [tags]="userTags"></shared-tags-strip-component></div>
                    <div class="container-tag"><span class="mini-title-tags" *ngIf="privateTags">{{'TAG.PRIVATE.CAPTION'
                            |
                            translate }}:</span><shared-tags-strip-component class="only-single"
                            [tags]="privateTags"></shared-tags-strip-component></div>
                    <div class="container-tag"><span class="mini-title-tags" *ngIf="stops">{{'TAG.STOP.CAPTION' |
                            translate
                            }}:</span><shared-tags-strip-component class="only-single"
                            [tags]="stops"></shared-tags-strip-component></div>
                    <div class="container-tag"><span class="mini-title-tags"
                            *ngIf="internalTags">{{'TAG.INTERNAL.CAPTION' |
                            translate }}:</span><shared-tags-strip-component class="only-single"
                            [tags]="internalTags"></shared-tags-strip-component></div>
                </div>
                <div *ngIf="showTimeline" class="container-tags timeline" [@fadeInOut]>
                    <routephase-timeline [routeId]="route.routeId"></routephase-timeline>
                </div>
            </div>
        </div>
    </div>
    <shared-route-strip-properties-component class="bottom-zone manualMarks"
        [route]="route"></shared-route-strip-properties-component>
    <div class="bottom-zone">
        <shared-route-strip-component [route]="route" class="showStatus in-bottom-zone"
            (optionClick)="optionClick.emit($event)"></shared-route-strip-component>
    </div>

    <!-- SEMÀFOR -->
    <span *ngIf="route.showMMResponseStatus && route.responseStatus != null" class="responseStatusContainer"
        [ngClass]="{'withdock' : route.docks != null && route.docks.length > 0 }">
        <div class="responseStatus" [ngClass]="route.responseStatus"></div>
    </span>

    <!-- FILLES -->
    <div *ngIf="route.isDivided && route.pendingChildsCount > 0" class="showchilds ichilds">
        <div class="contador">{{route.pendingChildsCount}}</div>
    </div>

    <!-- BANNER HTML PRIVAT -->
    <div *ngIf="route && route.styledBannerHtml" class="private-banner-html"
        [innerHTML]="route.styledBannerHtml | safe: 'html'">
    </div>
    <div *ngIf="route.styledPrivateBannerHtml" class="private-banner-html"
        [innerHTML]="route.styledPrivateBannerHtml | safe: 'html'">

        <!-- ID DE LA RUTA -->
        <div class="routeId">{{route.routeId}}</div>
    </div>